import {
  MANAGEMENT_LABEL,
  PERSONAL_PROFILE_LABEL,
} from "../../constants/Dictionary";
import { BreadcrumbItem, PageNames } from "../../types/AppTypes";
import { CollaboratorProfileTabs } from "../CollaboratorDetail/CollaborProfileTabs/CollaboratorProfileTabs";
import { useBreadCrumb } from "../../hooks/useBreadCrumbs.hooks";
import { useLocation } from "react-router-dom";

export const PersonalProfile = () => {
  const { pathname } = useLocation();
  const breadcrumbItems: BreadcrumbItem[] = pathname.includes(
    PageNames.MANAGEMENT,
  )
    ? [
        {
          name: MANAGEMENT_LABEL,
          pathName: PageNames.MANAGEMENT,
        },
        {
          name: PERSONAL_PROFILE_LABEL,
          pathName: PageNames.PERSONAL_PROFILE,
        },
      ]
    : [
        {
          name: PERSONAL_PROFILE_LABEL,
          pathName: PageNames.PERSONAL_PROFILE,
        },
      ];

  useBreadCrumb(breadcrumbItems);

  return <CollaboratorProfileTabs isMyProfile />;
};
